module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('appStatus', {
    attrs: {
      "statusHeight": _vm.statusHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "page-title",
    style: ({
      top: _vm.statusHeight + 'rem'
    })
  }, [_c('div', {
    staticClass: "color-333 fs-36"
  }, [_vm._v(_vm._s(_vm.countEntity.shopName || _vm.userName))]), _vm._v(" "), _c('div', {
    staticClass: "flex-center"
  }, [_c('div', {
    staticClass: "right-icon alifont icon-refresh click mr-20",
    on: {
      "click": _vm.refreshOrderCount
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right-icon alifont icon-xiaoxi click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'messageList'
        })
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "pd-025"
  }, [(_vm.isCabinetToolBuyerRole) ? _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "opc"
  }), _vm._v(" "), _c('div', {
    staticClass: "flex-center",
    staticStyle: {
      "position": "relative",
      "z-index": "10"
    }
  }, [_c('div', {
    staticClass: "flex1 text-center"
  }, [_c('div', {
    staticClass: "fs-28 color-fff"
  }, [_vm._v("今天取货数")]), _vm._v(" "), _c('div', {
    staticClass: "sale-money number_font click"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.todayNum / 1000 || 0)) + " "), _c('span', {
    staticClass: "fs-40"
  }, [_vm._v("kg")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex1 text-center"
  }, [_c('div', {
    staticClass: "fs-28 color-fff"
  }, [_vm._v("总取货数")]), _vm._v(" "), _c('div', {
    staticClass: "sale-money number_font click"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.totalNum / 1000 || 0)) + " "), _c('span', {
    staticClass: "fs-40"
  }, [_vm._v("kg")])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("管理")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.manageList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "com-content"
  }, [_c('div', {
    staticClass: "fs-36 color-333 font-bold"
  }, [_vm._v("设置")]), _vm._v(" "), _c('div', {
    staticClass: "content-list"
  }, _vm._l((_vm.settingList), function(item, $index) {
    return _c('div', {
      key: $index,
      staticClass: "content-item click",
      on: {
        "click": function($event) {
          return _vm.goUrl(item)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.img,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fs-28 color-333 mt-10"
    }, [_vm._v(_vm._s(item.name))])])
  }), 0)])]), _vm._v(" "), _c('img', {
    staticClass: "scan-img click",
    attrs: {
      "src": _vm.scanImg,
      "alt": ""
    },
    on: {
      "click": _vm.scan
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d4690a1","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/homeByToolCabinet.vue
// module id = 0dCH
// module chunks = 51